module.exports = __webpack_public_path__ + "img/mom-icon.e10cac45.png";